import { Badge, Button, Input, message, Modal, Table, Tag } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { get, post } from "../../../apiService";

const columns = [
  {
    title: "Price",
    dataIndex: "price",
    key: "price",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
];

export default function PriceHistory({ data }) {
  const [open, setOpen] = useState(false);
  const [priceList, setPriceList] = useState();
  const [newPrice, setNewPrice] = useState(""); // For the new price input

  const handleCancel = () => {
    setOpen(false);
  };

  const handleAddNewPrice = async () => {
    const currentDate = moment().format("MMMM Do YYYY, h:mm:ss a"); // Get the current date and time
    const formData = new FormData();
    formData.append("product_id", data?.product_id);
    formData.append("action", "addPrices");
    formData.append("price", newPrice);
    formData.append("type", data?.type);
    formData.append("priceType", data?.priceType);
    try {
      const response = await post(`/product.php`, formData);
      if (response) {
        setPriceList((prevList) => [
          { date: currentDate, price: parseFloat(newPrice) }, // Add new price with date
          ...prevList,
        ]);
        message.success("product price successfully");
      }
    } catch (error) {
      message.error("error adding new prices");
      console.log(error);
    } finally {
      setNewPrice("");
    }
  };

  const handlePriceHistory = async (value) => {
    const action = "fetchPrice";
    const type = value?.type;
    const priceType = value?.priceType;
    const product_id = value?.product_id;

    try {
      const response = await get(
        `/product.php?action=${action}&type=${type}&priceType=${priceType}&product_id=${product_id}`
      );
      if (response?.list) {
        setPriceList(response.list);
      } else {
        message.error("Invalid response format");
      }
    } catch (error) {
      message.error("Error fetching history price");
      console.log(error);
    }
  };

  useEffect(() => {
    const debounce = setTimeout(() => {
      if (open) handlePriceHistory(data);
    }, 500);

    return () => clearTimeout(debounce);
  }, [open]);

  return (
    <>
      {data?.price ? (
        <span onClick={() => setOpen(true)} className="priceText">
          $&nbsp;{data?.price}
        </span>
      ) : (
        "-"
      )}
      <Modal
        title={data?.priceType + " Price History"}
        centered
        open={open}
        onCancel={handleCancel}
        footer={[]}
      >
        <div className="d-flex gap-2 mb-4">
          <Input
            type="number"
            value={newPrice}
            onChange={(e) => setNewPrice(e.target.value)}
            placeholder="Enter new price"
            style={{ width: 200 }}
          />
          <Button
            type="primary"
            onClick={handleAddNewPrice}
            disabled={!newPrice}
          >
            Add Price
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={priceList?.map((value, index) => ({
            ...value,
            price: "$ " + value.price,
            created_at: moment(value.created_at).format("llll"), // Date formatting is good
            status: index === 0 ? <Tag color="#87d068"> Current</Tag> : null, // Render only when index is 0
          }))}
        />
      </Modal>
    </>
  );
}
